<div class="search-input-form">
    <input type="text" (input)="handleInputChange($event)" [placeholder]="placeholder">
    <button (submit)="onSubmit()" (click)="onSubmit()"><i class="bi bi-search"></i></button>
</div>
